module.exports = __webpack_public_path__ + "img/272-cross.fd9f422d.svg";